import Button from '@jobseeker/lotus/elements/ButtonV2';
import {Box, Typography, useTheme} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CTAProps} from '../type';
import {openUrl} from '@jobseeker/common-core/utils/common';

export default ({children, ...props}: CTAProps) => {
  const theme = useTheme();
  return (
    <Box
      data-testid="jobfeed_course_banner_cta"
      sx={{
        display: 'flex',
        width: '100%',
        // background: '#91B87966',
        px: 2,
        gap: theme.spacing(2),
        py: {xxs: 2, md: 2.5},
        justifyContent: 'flex-start',
        alignItems: {xxs: 'flex-start', md: 'center'},
        position: 'relative',
        borderBottom: 'solid 1px',
        borderColor: '#7E7E7E33',
        overflow: 'hidden',
        ':hover': {
          boxShadow: '6px 6px 14px 3px rgba(19, 21, 23, 0.04)',
          zIndex: 2,
          borderColor: '#fff',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          zIndex: 2,
          // flexWrap: 'wrap',
        }}
      >
        {props.imageUrl && (
          <Box
            sx={{
              width: 50,
              minWidth: 50,
              height: 50,
              position: 'relative',
              background: '#fff',
              borderRadius: '6px',
            }}
          >
            <Image
              alt="course image"
              src={props.imageUrl}
              layout="fill"
              objectFit="contain"
              quality={100}
              style={{
                borderRadius: '6px',
              }}
            />
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: {xxs: 'column', md: 'row'},
          width: '100%',
          justifyContent: 'space-between',
          alignItems: {xxs: 'flex-start', md: 'center'},
          gap: theme.spacing(2),
          zIndex: 2,
          pr: {xxs: 0, md: 4},
        }}
      >
        <Typography
          variant="subtitle2"
          maxWidth={{xxs: 'unset', md: '80%'}}
          lineHeight={'20px'}
        >
          {props.title}
        </Typography>
        <Button
          variant="outlined"
          disableRipple
          onClick={() => props.actionUrl && openUrl(props.actionUrl, '_blank')}
          sx={{
            minWidth: '105px',
            // background: '#fff',
            fontSize: theme.typography.pxToRem(12),
            whiteSpace: 'nowrap',
            py: 1,
            px: 2,
            // color: 'secondary.main',
            zIndex: 2,
            fontWeight: 500,
            lineHeight: '16px',
            borderRadius: 8,
            // ':hover': {background: '#efefef'},
          }}
          color="primary"
          size="small"
        >
          {props.actionLabel ?? 'Know more'}
        </Button>
      </Box>
      {/* <Box
        sx={{
          width: {xxs: 200, md: 300},
          height: {xxs: 200, md: 300},
          background: {
            xxs: 'linear-gradient(90deg ,#7E9F6733 0%, #22544833 100% )',
            sm: 'linear-gradient(90deg ,#7E9F67 0%, #225448 100% )',
          },
          position: 'absolute',
          borderRadius: '100%',
          right: {xxs: -100, sm: -35, md: -95},
          zIndex: 1,
          top: {xxs: -10, sm: -30, md: -70},
          transform: 'rotate(45deg)',
        }}
      ></Box> */}
    </Box>
  );
};
